import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const CreateTemplate = (data: any) => {
  return request({
    url: ApiURL.Command.CreateJsonTemplate,
    method: RequestType.POST,
    data
  });
};
const DeleteTemplate = (id: number) => {
  return request({
    url: `${ApiURL.Command.DeleteJsonTemplate}/${id}`,
    method: RequestType.DELETE
  });
};
const UpdateTemplate = (data: any) => {
  return request({
    url: `${ApiURL.Command.UpdateJsonTemplate}/${data.id}`,
    method: RequestType.PUT,
    data
  });
};
const JsonbuilderServiceCommand = {
  CreateTemplate,
  DeleteTemplate,
  UpdateTemplate,
};

export default JsonbuilderServiceCommand;
